import { useProfile } from '@/hooks/useProfile';

export function useFeatureAccess() {
  const { profile, isLoading } = useProfile();
  const planKey = profile?.plan_key || 'free';
  const isPro = planKey === 'pro';

  return {
    isPro,
    planKey,
    profile,
    isLoading,
  };
}